module.exports = __webpack_public_path__ + "img/03.3b274228.png";